import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import "../../App.css";

import HeroSection from "./HeroSection";
import StatisticsSection from "./StatisticsSection";
import AboutSection from "./AboutSection";
import CapabilitySection from "./CapabilitySection";
import ProcessSection from "./ProcessSection";
import BenefitSection from "./BenefitSection";
import IndustrySection from "./IndustrySection";
import FAQSection from "./FAQSection";
import CTASection from "./CTASection";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const ServiceDetails = () => {
  const { slug } = useParams();

  const [service, setService] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [slug]);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    try {
      setLoading(true);

     const [serviceRes, servicesRes] = await Promise.all([
  axios.get(`${API}/services/getbyslug/${slug}`),
  axios.get(`${API}/services/getAll`),
]);

      setService(serviceRes.data.data);
      setServices(servicesRes.data.data);
    } catch (err) {
      console.log(err);
      setService(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <h2 className="text-2xl font-semibold">Loading...</h2>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="flex justify-center items-center h-screen">
        <h2 className="text-4xl font-bold">Service Not Found</h2>
      </div>
    );
  }

  return (
    <div className="bg-[#f7f8fc] overflow-x-hidden">
      <div className="max-w-[1700px] mx-auto pt-28">

      

      

      
        {/* ================= CONTENT ================= */}

        <AnimatePresence mode="wait">
          <motion.div
            key={slug}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.35,
              ease: "easeInOut",
            }}
          >
            <HeroSection service={service} />

            <div className="mt-5">
              <StatisticsSection stats={service.stats} />
            </div>

            <AboutSection overview={service.overview} />

            <CapabilitySection features={service.features} />

            <div className="mt-5">
              <ProcessSection process={service.process} />
            </div>

            <div className="mt-5">
              <BenefitSection benefits={service.benefits} />
            </div>

            <IndustrySection
              industries={service.industries}
              technologies={service.technologies}
            />

            <div className="mt-5">
              <FAQSection faq={service.faq} />
            </div>

            <div className="mt-10 mb-10">
              <CTASection service={service} />
            </div>
          </motion.div>
        </AnimatePresence>

      </div>
    </div>
  );
};

export default ServiceDetails;